import { FormLayout } from 'components/common'
import { DynamicInputList } from 'components/common/dynamicInputList'
import { UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form'

type Props = {
  setValue: UseFormSetValue<FieldValues>
  clusters?: string[]
  errors?: FieldErrors<FieldValues>
}
const ClusterSection = ({ setValue, clusters, errors }: Props) => {
  return (
    <>
      <h3 className="title">Cluster Configuration</h3>
      <FormLayout>
        <DynamicInputList
          orientation="horizontal"
          label="Cluster"
          name="clusters"
          placeholder="Add Cluster"
          setValue={setValue}
          defaultValues={clusters}
          errors={errors}
          shouldDelete={false}
        />
      </FormLayout>
    </>
  )
}

export default ClusterSection
